import script from "./HeatmapsView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeatmapsView.vue?vue&type=script&setup=true&lang=js"

import "./HeatmapsView.vue?vue&type=style&index=0&id=0afb2b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afb2b16"]])

export default __exports__